export default {
	name: 'task_0_1',
	description: 'Заставка',
	title: 'Режим прохождения игры',
	minigameType: 'Intro',
	generateParams() {
		return {
            question: "Выберите сценарий прохождения игры",
			options: ["Случайные задачи", "Фиксированный порядок"],
			correct: [0]
        };
	},
	isCompleted: () => true,
};